module.exports = (__parcel__import__("4aY12")).then(() => parcelRequire('lmhgI'));